import { render, staticRenderFns } from "./SessionSetup.vue?vue&type=template&id=32c36171&scoped=true&"
import script from "./SessionSetup.vue?vue&type=script&lang=js&"
export * from "./SessionSetup.vue?vue&type=script&lang=js&"
import style0 from "./SessionSetup.vue?vue&type=style&index=0&id=32c36171&prod&scoped=true&lang=css&"
import style1 from "./SessionSetup.vue?vue&type=style&index=1&id=32c36171&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c36171",
  null
  
)

export default component.exports